export default __webpack_public_path__ + "static/comparisons-breadth-features-ca6325aa8d41f73ea5d8dcbeb49cf611.webp";